export default __webpack_public_path__ + "static/media/avatar.2c05bed9.jpg";